import { RemoteUpdateSector } from 'data/usecases';
import { makeApiUrlSectors } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeRemoteUpdateSector = (): RemoteUpdateSector => {
  return new RemoteUpdateSector(makeApiUrlSectors(), makeAxiosHttpClient());
};
